import { memo } from 'react';
import { Chip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CreditCardOutlined } from '@mui/icons-material';
import { PAYMENT_GATEWAYS_ENUM } from 'modules/sales/settings/payment-settings/constants';

type OrderPaymentMethodProps = {
  value: PAYMENT_GATEWAYS_ENUM;
};

const OrderPaymentGateway = ({ value }: OrderPaymentMethodProps) => {
  const { t } = useTranslation('order');

  if (!value) return <Typography>-</Typography>;

  return (
    <Chip
      sx={{ borderRadius: 1 }}
      icon={<CreditCardOutlined />}
      variant='outlined'
      label={t(`payment.gateway.${value}`)}
      size={'small'}
      color='warning'
    />
  );
};

export default memo(OrderPaymentGateway);
